export var Accounting = /*#__PURE__*/ function(Accounting) {
    Accounting["QBO"] = "qbo";
    Accounting["Xero"] = "xero";
    return Accounting;
}({});
